import React, { useState } from "react";
import {
  Card,
  CardContent,
  Button,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import { IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, Share } from "@mui/icons-material";
import { useRef } from "react";
import FavoriteIcon from '@mui/icons-material/Favorite';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useDispatch } from "react-redux";
import { toggleFavorite } from "../../redux/reducers/favoritesSlice";
import { useSelector } from "react-redux";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import YourProjectDetails from "./YourProjectDetails";
const YourProjectPlan = ({ data }) => {
  const navigate = useNavigate();
  const plots = data.plots || [];
  const [selectedPlot, setSelectedPlot] = useState(() => {
    return plots.find((plot) => plot.Status?.toLowerCase() !== "sold") || null;
  });
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const favoriteItems = useSelector(state => state.favorites.items);
   const themes = useSelector((state) => state.themeValue.colors);
  const modalRef = useRef();
  const userId = useSelector((state) => state.user.userId);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [transformOrigin, setTransformOrigin] = useState("center center");
  const containerRef = useRef();
  const handleDoubleClick = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;
    const originX = `${(offsetX / rect.width) * 100}%`;
    const originY = `${(offsetY / rect.height) * 100}%`;
    setTransformOrigin(`${originX} ${originY}`);
    // Toggle zoom: If zoomed in, zoom out. Else zoom in more.
    setZoomLevel((prev) => (prev > 1 ? 1 : 2));
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));  // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–899px
 
  // ✅ Dynamic column layout
  let columns = 3; // Default: 3 for laptop/desktop
  if (isTablet) columns = 3;
  if (isMobile) columns = 2; // <-- Now mobile also has 2 columns
 
  const numberOfRows = Math.ceil(data.number_of_plots / columns);
  const plotsMap = new Map(
    plots.map((p) => {
      const match = p.plotName.match(/\d+/);
      const plotNumber = match ? parseInt(match[0], 10) : null;
      return [plotNumber, p];
    })
  );
 
  const handlePlotSelect = (plot) => {
    if (plot.Status?.toLowerCase() !== "sold") {
      setSelectedPlot(plot);
    }
  };
  const renderGrid = () => {
    const grid = [];
    const totalPlots = data.number_of_plots;
    let plotNumber = 1;
    const plotDataMap = new Map();
    plots.forEach((p) => {
      const match = p.plotName.match(/\d+/);
      const number = match ? parseInt(match[0], 10) : null;
      if (number !== null) plotDataMap.set(number, p);
    });
    for (let i = 0; i < numberOfRows; i++) {
      const row = [];
      for (let j = 0; j < columns; j++) {
        if (plotNumber > totalPlots) break;
        const plot = plotDataMap.get(plotNumber);
        const isSold = plot?.Status?.toLowerCase() === "sold";
        const isSelected = selectedPlot?.plotName === plot?.plotName;
        row.push(
          <Box
            key={`plot-${plotNumber}`}
            onClick={() => {
              if (!plot) {
                navigate("/addPlot", {
                  state: {
                    data: {
                      projectId: data.id,
                      projectName: data.project_name,
                      address: data.address,
                      city: data.city
                    },
                  },
                });
              } else if (!isSold) {
                setSelectedPlot(plot);
              }
            }}
            sx={{
              width: 100,
              height: 100,
              border: 2,
              m: 0.5,
              borderRadius: 2,
              backgroundColor: isSold
                ? "#FF4D4D"
                : isSelected
                  ? "#B3E5FC"
                  : plot
                    ? "#D0F0C0"
                    : "#fff",
              borderColor: isSelected
                ? "primary.main"
                : isSold
                  ? "error.dark"
                  : "grey.800",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: isSold ? "not-allowed" : "pointer",
              transition: "all 0.2s ease-in-out",
              boxShadow: isSelected ? 4 : 1,
            }}
          >
            {plot ? (
              <>
                <Typography fontWeight="bold">{plot.plotName}</Typography>
                <Typography fontSize={12}>
                  {plot.SizeInSqFt} sqft
                </Typography>
                <Typography fontSize={12}>
                  ₹{plot.SqFtPrice}/sqft
                </Typography>
                {isSold && (
                  <Typography
                    fontSize={12}
                    fontWeight="bold"
                    color="white"
                  >
                    SOLD
                  </Typography>
                )}
              </>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center">
                <AddIcon sx={{ color: "green", fontSize: 20 }} />
                <Typography fontSize={12}>Add Details</Typography>
              </Box>
            )}
          </Box>
        );
        plotNumber++;
      }
      grid.push(
        <Box key={`row-${i}`} display="flex" justifyContent="flex-start">
          {row}
        </Box>
      );
    }
    return grid;
  };
  const encryptionKey = 'yourSecretKey';
  const scrollRef = useRef(null);
  const getUniqueId = (data) => `${data.type}_${data.id}`;
  const toggleLike = (property) => {
    const uniqueId = getUniqueId(property);
    dispatch(toggleFavorite(uniqueId));  // Dispatch to Redux
  };
  const isLiked = (property) => {
    const uniqueId = getUniqueId(property);  // Get the unique ID for the property
    return favoriteItems.includes(uniqueId);  // Check if it's liked (from Redux state)
  };
  return (
    <>
      <Box
        sx={{
          padding: {xs:1,ms:3},
          width: "100%",
          margin: "auto",
          backgroundColor: themes.background,
          borderRadius: 2,
          display: "flex",
          flexDirection: {
            xs: "column",   // <600px
            sm: "column",   // 600px–900px
            md: "row",      // ≥900px or ≥1000px
          },
          gap: 2,
        }}
      >
        {/* Left side - Plots */}
        <Box
          sx={{
            position: "relative", // for positioning arrows
            width: {
              xs: "100%",   // <600px
              sm: "100%",   // 600px–900px
              md: "40%",      // ≥900px or ≥1000px
            },
            height: 400,
            maxHeight: 400,
            display: "flex",
            justifyContent:{xs:"start",sm: "center"},
            // backgroundColor:"red"
          }}
        >
          <Box
            sx={{
              position: "relative", // for positioning arrows
              width:{xs:"85%",sm: "82%"}
            }}
          >
            {/* Scrollable area */}
            <Box
              ref={scrollRef}
              sx={{
                width: "100%",
                height: {
                  xs: '100vh',
                  sm: '80vh',
                  md: '60vh',
                },
                backgroundColor: "#F5F5F5",
                borderRadius: 2,
                padding: 2,
                maxHeight: 400,
                display: "flex",
                flexDirection: "column", // changed to vertical
                overflowY: "auto",        // vertical scroll
                overflowX: "hidden",      // no horizontal scroll
                scrollBehavior: "smooth",
               
                alignItems:"center"
              }}
            >
              {renderGrid()}
            </Box>
          </Box>
          {/* Share and Heart Icon */}
          <Box
            sx={{
              marginLeft: "40px",
              flexDirection: "column",
              justifyContent: "flex-end",
               position: "absolute",
                bottom: "5%",
                right: "-5px", // Make sure the child absolute positioning works
              // padding:"10px",
              // backgroundColor:"blue"
            }}
          >
            <Box
              sx={{
                // Keep arrows aligned to the right
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1, // space between buttons
                // backgroundColor:"red",
                // paddingLeft:"5px",
                // marginLeft:10
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: 2,
                  borderRadius: 2,
                }}
                onClick={() =>
                  scrollRef.current.scrollBy({
                    top: -scrollRef.current.clientHeight,
                    behavior: "smooth",
                  })
                }
              >
                <KeyboardArrowUpIcon sx={{ color: themes.normal_icon }} />
              </IconButton>
 
              <IconButton
                sx={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: 2,
                  borderRadius: 2,
                }}
                onClick={() =>
                  scrollRef.current.scrollBy({
                    top: scrollRef.current.clientHeight,
                    behavior: "smooth",
                  })
                }
              >
                <KeyboardArrowDownIcon sx={{ color: themes.normal_icon }} />
              </IconButton>
            </Box>
          </Box>
 
        </Box>
        {/* Right side - Selected Plot Details */}
        <YourProjectDetails data={data} selectedPlot={selectedPlot}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          selectedProperty={selectedProperty}
          setSelectedProperty={setSelectedProperty}
        />
      </Box></>
  );
};
export default YourProjectPlan;